import { RootState } from '../../store';

export const getStreetsSelector = (state: RootState) => state?.streetReducer?.streets;
